import { AutomateTask, success } from "@iflyrpa/share";
import { errorResponse } from "../../types";
import { Http } from "../../utils/http";
import { type SearchAccountInfoParams } from ".";
import { SearchAccountInfoResponse, ttConfigData } from "./types";

export async function getToutiaoData(
    _task: AutomateTask,
    params: SearchAccountInfoParams,
): Promise<SearchAccountInfoResponse> {
    const http = new Http({
        headers: {
            cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            referer: "https://mp.toutiao.com/profile_v4/graphic/publish",
            "user-agent":
                "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/124.0.0.0 Safari/537.36",
        },
    });

    const totalData = await http.api<{
        message: string;
        data?: {
            statistic: {
                data: {
                    total_subscribe_count: string;
                    total_read_play_count: string;
                    total_income: number;
                    yesterday_income: number;
                    is_yesterday_income_ready: boolean;
                    yesterday_fans?: string;
                    yesterday_play_count: string;
                    yesterday_read_count: string;
                };
            };
        };
    }>({
        method: "get",
        url: "https://mp.toutiao.com/mp/fe_api/home/merge_v2",
        params: { app_id: 1231 },
    });

    await new Promise((r) => setTimeout(r, 1000));

    const contentDataYesterday = await http.api<{
        message: string;
        author_stat?: {
            consume_data: { impression_count: number; go_detail_count: number };
            interaction_data: { comment_count: number; digg_count: number };
        };
    }>({
        method: "get",
        url: "https://mp.toutiao.com/mp/agw/statistic/v2/content_stat",
        params: { type: 0, app_id: 1231 },
    });

    const isSuccess = !!(totalData?.data?.statistic && contentDataYesterday?.author_stat);

    if (!isSuccess || !totalData?.data || !contentDataYesterday?.author_stat) {
        return errorResponse(
            totalData?.message || contentDataYesterday?.message || "头条号数据获取失败，请检查Cookie是否有效",
            414,
        );
    }

    const ttData: ttConfigData = {
        fansNum: Number(totalData.data.statistic.data.total_subscribe_count),
        fansNumYesterday:
            totalData.data.statistic.data.yesterday_fans !== undefined
                ? Number(totalData.data.statistic.data.yesterday_fans)
                : null,
        readNum: Number(totalData.data?.statistic.data.total_read_play_count),
        incomeNum: totalData.data?.statistic.data.total_income,
        incomeNumYesterday: totalData.data?.statistic.data.is_yesterday_income_ready
            ? totalData.data.statistic.data.yesterday_income
            : null,
        showNumYesterday: contentDataYesterday.author_stat.consume_data.impression_count,
        readNumYesterday: contentDataYesterday.author_stat.consume_data.go_detail_count,
        likeNumYesterday: contentDataYesterday.author_stat.interaction_data.digg_count,
        commentNumYesterday: contentDataYesterday.author_stat.interaction_data.comment_count,
    };

    return success(ttData, "头条号粉丝数据获取成功！");
}
